import { render, staticRenderFns } from "./ProductCreateUpdate.vue?vue&type=template&id=0bf3fce2&"
import script from "./ProductCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports